export default {
    functional: true,
    render(createElement, { props, children, _v }) {
        if (props.responded) return children;
        return _v('—');
    },
};
